import { render, staticRenderFns } from "./MajorForm.vue?vue&type=template&id=1811f8e2&scoped=true&"
import script from "./MajorForm.vue?vue&type=script&lang=js&"
export * from "./MajorForm.vue?vue&type=script&lang=js&"
import style0 from "./MajorForm.vue?vue&type=style&index=0&id=1811f8e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1811f8e2",
  null
  
)

export default component.exports